import styled from "styled-components";
import { rem, em } from "convert-to-ems";
import Button from "../../../shared/Button/Button";

export const CellImgElement = styled.img`
   {
    width: ${rem(13)};
    height: ${rem(21)};
    margin-top: ${rem(18)};
  }
`;

export const RechargeValuePriceElement = styled.div`
   {
    margin-top: ${rem(10)};
    margin-left: ${rem(1)};
    font-size: ${em(32)};
  }
`;

export const RechargeValueBonusElement = styled.div`
   {
    margin-top: ${rem(5)};
    color: #e3262e;
    font-size: ${em(18)};
    opacity: 1;
  }
`;

export const RechargeValueButtonElement = styled(Button)`
   {
    margin-top: ${props => (props.haveBonus ? rem(17) : rem(42))};
  }
`;

export const RechargeValueValidateElement = styled.div`
   {
    margin-top: ${rem(10)};
    margin-left: ${rem(1)};
    font-family: "Roboto";
    color: #5f646d;
    font-size: ${em(11)};
    opacity: 0.5;
    height: 26px;
  }
`;
